var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.errorText!=='')?_c('Snackbar',[_vm._v(_vm._s(_vm.errorText))]):_vm._e(),_c('router-view'),(_vm.showLoading)?_c('MaskLoading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }